<template>
  <span class="text-left">
    <ed-button class="btn btn-actionbar"
        @click="validateInvoices()"
        :disabled='disabled'
      >Remit Payment
    </ed-button>

    <ed-modal
      :show='showModal'
      @close='showModal = false'
      title=''
      xsubtitle=''
      primaryButton='OK'
      secondaryButton='false'
    >
      <span slot="body">
        <p class="col-md-8 lh15">
          <span v-html="modalContent"></span>
        </p>
        <div class="clear"></div>
      </span>
    </ed-modal>
  </span>
</template>

<script>
export default {
  props: {
    rows: Array
  },

  data() {
    return {
      showModal: false,
      modalContent: ''
    }
  },

  methods: {
    validateInvoices() {
      if (!this.rows || this.rows.length > 1) {
        this.modalContent = 'Payment can only be made for one credit invoice at a time. Please deselect all invoices except for one and try again.'
        this.showModal = true
      } else {
        this.api.forms.post(
          this.api.$.invoice.list.validateRemitPayment,
          {
            isAllSelected: false,
            selection: JSON.stringify([this.rows[0].data.PaymentInvoiceID]),
            filter: '',
            paymentType: 'remit'
          }
        ).then(result => {
          if (result && result.data) {
            if (result.data.SuccessMessage !== 'Success') {
              this.modalContent = result.data.Data
              this.showModal = true
            } else {
              this.redirectToRemitPayment()
            }
          }
        })
      }
    },

    redirectToRemitPayment() {
      if (this.rows && this.rows.length === 1) {
        this.$router.push('/d/Invoices/remit-payment/' + this.rows[0].data.PaymentInvoiceID)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/Invoices/actions/remit-payment.vue